import { render, staticRenderFns } from "./DocumentLibraryViewer.vue?vue&type=template&id=c43fd97c&"
import script from "./DocumentLibraryViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentLibraryViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports